import { Card, CardContent } from "./ui/card";
import { Badge } from "./ui/badge";
import { 
  Mountain, 
  Camera, 
  Waves, 
  Plane, 
  Palette, 
  TreePine,
  MapPin,
  Clock
} from "lucide-react";
import { ImageWithFallback } from "./figma/ImageWithFallback";

const attractions = [
  {
    name: "Lake Mead Recreational Area",
    description: "Enjoy boating, fishing, kayaking, and lakeside picnics with beautiful scenery.",
    distance: "Minutes away",
    icon: Waves,
    image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
  },
  {
    name: "Valley of Fire State Park",
    description: "46,000 acre park with red sandstone outcrops and 3,000 year old petroglyphs.",
    distance: "Short drive",
    icon: Mountain,
    image: "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
  },
  {
    name: "Hoover Dam Visitor Center",
    description: "Modern civil wonder that harnesses the Colorado River. Watch for Desert BigHorn Sheep!",
    distance: "Boulder City",
    icon: Camera,
    image: "https://images.unsplash.com/photo-1580130775562-0ef92da028de?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
  },
  {
    name: "Red Rock Canyon",
    description: "Scenic drive through colorful desert landscape with hiking trails and camping.",
    distance: "Day trip",
    icon: TreePine,
    image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
  },
  {
    name: "The Lost City Museum",
    description: "Learn about Ancestral Puebloans with artifacts and replicas of ancient life.",
    distance: "Local",
    icon: Palette,
    image: "https://images.unsplash.com/photo-1594736797933-d0c0fe25a854?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
  },
  {
    name: "Skydiving Adventures",
    description: "Adrenaline seekers can tandem skydive at Perkins Field Overton Airport.",
    distance: "Local",
    icon: Plane,
    image: "https://images.unsplash.com/photo-1540979388789-6cee28a1cdc9?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
  }
];

const nearbyCities = [
  { city: "Las Vegas, NV", time: "1 hour West", icon: MapPin },
  { city: "Mesquite, NV", time: "45 minutes North", icon: MapPin },
  { city: "St. George, UT", time: "1 hour 15 minutes North", icon: MapPin },
  { city: "Boulder City, NV", time: "1 hour 25 minutes South", icon: MapPin }
];

export function AttractionsSection() {
  return (
    <section id="attractions" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            Local & Nearby Attractions
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Discover the natural beauty and rich history of Nevada with these amazing nearby destinations
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {attractions.map((attraction, index) => (
            <Card key={index} className="overflow-hidden hover:shadow-lg transition-shadow">
              <div className="relative h-48">
                <ImageWithFallback
                  src={attraction.image}
                  alt={attraction.name}
                  className="w-full h-full object-cover"
                />
                <Badge 
                  variant="secondary" 
                  className="absolute top-3 right-3 bg-white/90 text-primary"
                >
                  {attraction.distance}
                </Badge>
              </div>
              <CardContent className="p-6">
                <div className="flex items-start gap-3 mb-3">
                  <div className="bg-primary/10 p-2 rounded-lg flex-shrink-0">
                    <attraction.icon className="h-5 w-5 text-primary" />
                  </div>
                  <h3 className="font-semibold">{attraction.name}</h3>
                </div>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {attraction.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="bg-muted/30 rounded-lg p-8">
          <h3 className="text-2xl font-semibold mb-6 text-center">
            Nearest Cities to Overton
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
            {nearbyCities.map((city, index) => (
              <div key={index} className="flex items-center gap-3 bg-white p-4 rounded-lg">
                <Clock className="h-5 w-5 text-primary flex-shrink-0" />
                <div>
                  <p className="font-medium">{city.city}</p>
                  <p className="text-sm text-muted-foreground">{city.time}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}